import { required, requiredIf, minLength } from "vuelidate/lib/validators";

const step1 = [
  "form.applicant",
  "form.organizations",
  "form.international",
  "form.hasProgramme",
  "form.isOther",
  "form.isInternal"
];

const requireNonBusiness = function(m) {
  return ["essential", "both"].indexOf(m.type) >= 0;
};

const requireAuthorization = function(m) {
  return m.type === "logistic";
};

const requireOrganizations = function(m) {
  return ["logistic", "essential", "none"].includes(m.applicant.type);
};

const step1Validations = {
  applicant: {
    type: { required },
    nonBusiness: { required: requiredIf(requireNonBusiness) },
    authorized: { required: requiredIf(requireAuthorization) }
  },
  organizations: {
    required: requiredIf(requireOrganizations),
    $each: {
      name: { required, minLengthNazwa: minLength(3) },
      type: { required },
      authorized: {
        required: requiredIf(requireAuthorization)
      },
      nonBusiness: {
        required: requiredIf(requireNonBusiness)
      }
    }
  },
  international: { required },
  hasProgramme: { required },
  isOther: { required },
  isInternal: { required }
};

export { step1Validations, step1 };
